import {RolesPesquisa} from "@components/roles/RolesPesquisa.tsx";
import {PermissoesPesquisa} from "@components/seguranca/PermissoesPesquisa.js";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {IRole} from "@models/roles/roles.ts";
import type {IPermissao} from "@models/seguranca/permissaoApp.js";
import {Button, Grid, IconButton, Tooltip} from "@mui/material";
import React, {useEffect, useState} from "react";
import {IPagination} from "@localization/siteMap/siteMapInterfaces.ts";
import {useRoles} from "@components/roles/hooks/useRoles.ts";
import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {Typography} from "@mui/joy";
import {DeleteOutline} from '@mui/icons-material'

interface IAssociarPermissaoRoleProps {

}

export const AssociarPermissaoRolesPage: React.FC<IAssociarPermissaoRoleProps> = () => {
    const {createAlertFromResponse} = useAlert()
    const {getRolePermissoes, removeRolePermissao, addRolePermissao} = useRoles()
    const [role, setRole] = useState<IRole | undefined>(undefined);
    const [permissao, setPermissao] = useState<IPermissao | undefined>(undefined);

    const [pagination, setPagination] = useState<IPagination>({page: 0, pageSize: 10})
    const [permissoes, setPermissoes] = useState<IPermissao[]>([])

    useEffect(() => {
        if (pagination.page <= 0) {
            setPagination(prev => ({...prev, page: 1}))
            return;
        }

        if (role != null) {
            setPagination(prev => ({...prev, loading: true}))

            getRolePermissoes({data: {roleId: role.id}, pagination: pagination}).then(x => {
                setPermissoes(x.items ?? [])
                setPagination(prev => ({
                    ...prev,
                    ...x.pagination
                }))
            }).finally(() => {
                setPagination(prev => ({...prev, loading: false, ignoreCache: false}))
            })
        }
    }, [pagination.page, pagination.ignoreCache == true]);

    useEffect(() => {
        if (role != null) {
            setPagination(prev => ({...prev, page: 0}))
            return;
        }

        setPermissoes([])
    }, [role]);


    return (
        <Grid container spacing={1}>
            <Grid size={6}>
                <RolesPesquisa onItemSelected={(r) => {
                    setRole(r)
                }}/>
            </Grid>
            <Grid size={6}>
                <PermissoesPesquisa onItemSelected={(p) => {
                    setPermissao(p)
                }}/>
            </Grid>
            <Grid size={12}>
                <Button variant={'outlined'} onClick={() => {
                    if (role && permissao)
                        addRolePermissao({
                            data: {
                                roleId: role.id,
                                permissoes: [permissao.nome]
                            }
                        }).then(x => {
                            createAlertFromResponse(x)
                            if (x.status == 'Success') {
                                setPagination(prev => ({...prev, ignoreCache: true, page: 0}))
                            }
                        })
                }}>
                    Enviar
                </Button>
            </Grid>
            {role != null &&
                <DefaultContainer innerSx={{my: 1}} pageProps={{pagination, setPagination}}>
                    {permissoes.map(x => {
                        return (<Grid size={12} container alignItems={'center'} justifyContent={'space-between'}
                                      component={Tooltip} title={x.descricao}>
                            <Typography>{x.nome}</Typography>
                            <IconButton onClick={() => {
                                if (role?.id != null)
                                    removeRolePermissao({data: {roleId: role.id, permissoes: [x.nome]}}).then((x) => {
                                        createAlertFromResponse(x)
                                        setPagination(prev => ({...prev, ignoreCache: true}))
                                    })
                            }}>
                                <DeleteOutline/>
                            </IconButton>
                        </Grid>)
                    })}
                </DefaultContainer>}

        </Grid>
    );
}